var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppNavigationItem',{attrs:{"name":_vm.title},on:{"click":_vm.toggleCollapse}})
}
var staticRenderFns = []

export { render, staticRenderFns }